import instance from "./axios.config";

const addEventType = (payload) =>
    instance.post("/event/addevent", payload);

const deleteEventType = (id) =>
    instance.put(`/event/delete-event/${id}`, {});

const updateEventType = (payload) =>
    instance.put("/event/update-event", payload);

const getAllEvents = () => instance.get(`/event/allevents`);
const getInspectionAllEvent = (subscriptionname) => instance.get(`/event/inspectionevents/${subscriptionname}`);
const getallReportEvents = (name) => instance.get(`/event/allreportevents/${name}`);

const getallModules = () => instance.get(`/event/getmodule`);

const eventService = {
    deleteEventType,
    updateEventType,
    addEventType,
    getAllEvents,
    getallModules, getallReportEvents,getInspectionAllEvent

};
export default eventService;
